/**
* Intercom integration, used to control the Intercom icon (Customer Success Tool).
*/
/* @ngInject */
function intercomService ($window, $timeout, $rootScope, CONSTANTS, Utils) {
  var key = CONSTANTS.INTERCOM_KEY
  var api = {
    initialize,
    trackEvent,
    startTour,
    show,
    shutdown
  }
  return api

  /**
   * Initializes the intercom integration.
   * @param {oParams} object - Parameter used on integration services.
   * @param {oParams.user} object - User data.
   * @param {oParams.company} object - Customer Company data.
   */
  function initialize (oParams) {
    const { user, company } = oParams

    if (!$window.Intercom) {
      return
    }

    return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      const hasIntercomFeature = features['GENERAL.INTERCOM_CHAT']

      if (Utils.isInReactNativeWebView() || (!hasIntercomFeature && $rootScope.isUser())) {
        $timeout(() => {
          $window.Intercom('update', { hide_default_launcher: true })
        }, 100)
      } else {
        $window.Intercom('update', { hide_default_launcher: false })
      }

      $window.Intercom('boot', {
        app_id: key,
        email: user.email,
        name: user.name,
        Role: user.role,
        onboarding_status: user.onboarding_status,
        onboarding_job: user.onboarding_job,
        locale: user.locale,
        Company: company.name,
        company: {
          id: company.id,
          name: company.formattedName,
          created_at: company.createdAt,
          size: company.size,
          onboarding_mkt_team_size: company.onboarding_mkt_team_size,
          onboarding_industry: company.onboarding_industry,
          onboarding_stores_count: company.onboarding_stores_count,
          onboarding_origin: company.onboarding_origin,
          url_prefix: company.subdomain || 'app'
        }
      })

      return oParams
    })
  }

  function trackEvent (eventName, metadata) {
    if (!$window.Intercom || !eventName) {
      return
    }

    $window.Intercom('trackEvent', eventName, metadata)
  }

  function startTour (tourId) {
    if (!$window.Intercom || !tourId) {
      return
    }

    $window.Intercom('startTour', tourId)
  }

  function show () {
    if (!$window.Intercom) {
      return
    }

    $window.Intercom('show')
  }

  function shutdown () {
    if (!$window.Intercom) {
      return
    }

    $window.Intercom('shutdown')
  }
}

export { intercomService }
